import { mutatorAction } from 'satcheljs';
import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getFreeBusyCacheStore } from '../store/store';
import { getSessionData } from '../selectors/sessionSelectors';
import type { MailboxInfo } from 'owa-client-types';

export const addSessionMutator: (
    sessionId: string,
    mailboxInfo: MailboxInfo,
    filterEvent?: CalendarEvent
) => void = mutatorAction(
    'addSessionMutator',
    (sessionId: string, mailboxInfo: MailboxInfo, filterEvent?: CalendarEvent): void => {
        getFreeBusyCacheStore().sessionMap.set(sessionId, {
            mailboxInfo,
            attendees: [],
            filterEvent,
        });
    }
);

export const removeSessionMutator: (sessionId: string) => void = mutatorAction(
    'removeSessionMutator',
    (sessionId: string): void => {
        getFreeBusyCacheStore().sessionMap.delete(sessionId);
    }
);

export const setSessionFilterEventMutator: (
    sessionId: string,
    filterEvent?: CalendarEvent
) => void = mutatorAction(
    'setSessionFilterEventMutator',
    (sessionId: string, filterEvent?: CalendarEvent): void => {
        const sessionStore = getSessionData(sessionId);

        if (sessionStore) {
            sessionStore.filterEvent = filterEvent;
        }
    }
);
